import { Close } from '@mui/icons-material';
import { Typography } from '@mui/material';
import cn from 'classnames';
import { observer } from 'mobx-react-lite';
import * as React from 'react';

import { useUiStore } from '@/configs/store';
import { AlertParams } from '@/configs/store/AlertsStore';

import { parseMessageWithMarkers } from '../utils';

import s from './Alert.module.scss';

type Props = AlertParams & {
  onRemove: (id: string) => void;
  className?: string;
};

const Alert: React.FC<Props> = observer(
  ({
    id,
    message,
    onRemove,
    className,
    withReload = true,
    title = 'Сервер не отвечает',
    iconConfig,
    icon: deprecatedIcon,
    links,
  }) => {
    const { isTabletAndLower } = useUiStore();
    const messageContent = parseMessageWithMarkers(message, links);

    // Поддержка старого API (icon) и нового (iconConfig)
    const IconComponent = iconConfig?.icon || deprecatedIcon;
    const iconColor = iconConfig?.color;

    return (
      <div className={cn(className, s.alert, { [s.alert_mobile]: isTabletAndLower })}>
        <div className={s.alert__top}>
          {IconComponent && (
            <IconComponent sx={{ color: iconColor, width: '20px', height: '20px' }} />
          )}
          <Typography variant="h6">{title}</Typography>
        </div>
        <Typography>
          {messageContent}
          {withReload && (
            <>
              ,<br />
              попробуйте{' '}
              <Typography
                component="span"
                onClick={() => window.location.reload()}
                sx={{
                  textDecoration: 'underline',
                  cursor: 'pointer',
                  '&:hover': { opacity: 0.8 },
                }}
              >
                обновить страницу
              </Typography>
            </>
          )}
        </Typography>
        <Close
          onClick={() => onRemove(id)}
          className={s.alert__close}
          style={{ cursor: 'pointer' }}
        />
      </div>
    );
  },
);

export default Alert;
